import { UseGetClassEventsWithFiltersByGymIdArgs } from "../api/queries/classEvent/useGetClassEventsWithFiltersByGymIdQuery";
import { makeQuery } from "../helper/query";
import $api from "../http";
import {
  ICancelReservationModel,
  IClassCategory,
  IClassEvent,
  IClassEventTimeRange,
  ICreateReservationModel,
  TAttendedClassEvent,
  TUpcomingClassEvent,
} from "../models/ClassEvent";
import { IOpenGym } from "../models/OpenGym";

class ClassEventServiceClass {
  async getClassEventsByDayAndGym(gymListingId: string, date: string, userId: string | null) {
    let query = `?date=${date}`;
    if (userId) query += `&userId=${userId}`;
    return await $api.get<IClassEvent[]>(
      `api/class-event/all-by-gym-and-date/${gymListingId}${query}`
    );
  }

  async createReservation(model: ICreateReservationModel) {
    return await $api.post<{}>(`api/class-event/reservation/create`, {
      ...model,
    });
  }

  async cancelReservation(model: ICancelReservationModel) {
    return await $api.post<{}>(`api/class-event/reservation/cancel`, model);
  }

  async getUpcomingClassEvents() {
    return await $api.get<TUpcomingClassEvent[]>(`api/class-event/reservation/upcoming`);
  }

  async getAttendedClassEvents() {
    return await $api.get<TAttendedClassEvent[]>(`api/class-event/reservation/attended`);
  }

  async getClassEventReservationById(classEventId: number | null, gymListingId: string | null) {
    return await $api.get<any>(
      `api/class-event/by-id/${classEventId}?gymListingId=${gymListingId}`
    );
  }

  async getClassEventsByDateAndGymId(gymId: string, date?: string, userId?: string) {
    let mainUrl = `api/class-event/all-by-gym-and-date/${gymId}?date=${date}`;

    if (userId) {
      mainUrl += `&userId=${userId}`;
    }

    return await $api.get<IClassEvent[]>(mainUrl);
  }

  async getAllClassCategories() {
    return await $api.get<IClassCategory[]>("api/class-category");
  }

  async getTimeRangesForClasses() {
    return await $api.get<IClassEventTimeRange[]>("api/class-event/time-ranges");
  }

  async getClassEventsByGymWithFilters(args: UseGetClassEventsWithFiltersByGymIdArgs) {
    if (!args.gymListingId) {
      throw new TypeError("getClassEventsByGymWithFilters: gymListingId is required");
    }

    const query = makeQuery({
      userId: args.userId,
      categoryIds: args.categoryIds,
      eventDate: args.eventDate,
      timeRanges: args.timeRanges,
      classLevels: args.classLevels,
      minCredits: args.minCredits,
      maxCredits: args.maxCredits,
    });

    return await $api.get<(IClassEvent | IOpenGym)[]>(
      `api/class-event/by-gym-with-filters/${args.gymListingId}${query}`
    );
  }
}

export const ClassEventService = new ClassEventServiceClass();
